export enum Path {
  HOME = '/',
  GLOSSARY = '/glossary',
  WHATSCOMMING = '/whatscoming',
  ABOUT = '/#about',
  THERAPY = '/therapy',
  SIGNIN = '/signin',
  SIGNOUT = '/signout',
}
